<div class="p-0 m-0" style="color: white" role="button" (click)="showModal(detailModal)">
    <div *ngIf="!inHiding && (uploadingPhotoCnt>0||errorPhotoCnt>0||pendingPhotoCnt>0); else noActivity"
        class="d-flex flex-row text-nowrap m-0 bg-dark">

        <div *ngIf="pendingPhotoCnt||uploadingPhotoCnt" class="status-cell">
            <i class="fa fa-sync" style="color:orange;"></i> {{pendingPhotoCnt+uploadingPhotoCnt}} unsynced
        </div>
        <div *ngIf="uploadingPhotoCnt" class="status-cell">
            <i class="fa fa-cloud-upload-alt blink"></i> {{uploadingPhotoCnt}}
        </div>
        <div *ngIf="errorPhotoCnt" class="status-cell">
            <i class="fa fa-exclamation-triangle" style="color:red;"></i> {{errorPhotoCnt}}
        </div>
        <div class="status-cell">
            photo(s)
        </div>
    </div>
</div>    

<ng-template #noActivity>
    <div *ngIf="!inHiding" title="Photo upload status and history">
    <i class="m-auto fa fa-camera"></i>
    </div>
</ng-template>

<ng-template #detailModal>
    <div class="d-flex flex-row justify-content-between px-3 py-1">
        <div class="h5 w-100">Photo(s) Uploads</div>
        <div>
            <button type="button" class="close"  (click)="detailModalRef.hide()">
                &times;
            </button>
        </div>
    </div>

    <div class="modal-body text-center">
        <div *ngIf="showDetailsPanel">
            <app-scout-photos-status-panel 
                [errorPhotoCnt]="errorPhotoCnt"
                [pendingPhotoCnt]="pendingPhotoCnt"
                [uploadingPhotoCnt]="uploadingPhotoCnt">
            </app-scout-photos-status-panel>
        </div>
        <button type="button" [disabled]="bRestartingUploader" class="btn btn-danger m-2" (click)="restartUploader()" >Force Upload Queue Restart</button>
        <button type="button" class="btn btn-primary m-2" (click)="detailModalRef.hide()" >Close</button>
    </div>
</ng-template>

